import { apiFetch } from "~/lib/fetchClient";

export const labelApi = {
  /**
   * Fetches labels.
   * @param {object} params - { query, page, per }
   */
  fetchLabels: (params = {}) => apiFetch.get("/labels", { params }),

  /**
   * Creates a new label.
   * @param {object} label - { name }
   */
  createLabel: (label) => apiFetch.post("/labels", { json: { label } }),

  /**
   * Updates an existing label.
   * @param {object} label - { id, name }
   */
  updateLabel: (label) => apiFetch.put(`/labels/${label.id}`, { json: { label } }),

  /**
   * Deletes a label.
   * @param {string} labelId
   */
  deleteLabel: (labelId) => apiFetch.delete(`/labels/${labelId}`),
};
